
/* GetResellers */

export class Dealer {
    public address: string;
    public fax: string;
    public isWebSeller: boolean;
    public lat: number;
    public lng: number;
    public mail: string;
    public telephone: string;
    public webSite: string;
    public name: string;
    public isOpen: boolean;
}

export class Position {
    public address: string;
    public lat: number;
    public lng: number;
}

export class GetResellersResult {
    public customers: Dealer[];
    public position: Position;
    public result: GetResellersResultCode;
}

export enum GetResellersResultCode {
    Ok = 0,
    NeedAddress = 1,
    NeedCaptcha = 2,
    RequestLimitReached = 3,
    NotFound = 4,
    FailedCaptcha = 5,
    Error = 6,
    NotFoundInCountry = 7,
    OverQueryLimit = 8
}

export enum FilterType {
    None = 0, OnlyRsc55, OnlyWorkwear
}

/* SendWishListToDealer */

export class SendWishListToDealerInput {
    public name: string;
    public surname: string;
    public mail: string;
    public phone: string;
    public privacy: boolean;
    public counter: number;
    public wishList: WishListItem[];
    public captcha: string;
}

export class WishListItem {
    public code: string;
    public description: string;
    public quantity: number;
}

export class SendWishListToDealerResult {
    public result: boolean;
}


/* SendWishList */

export class SendWishListInput {
    public name: string;
    public surname: string;
    public mail: string;
    public captcha: string;
    public privacy: boolean;
}

export class SendWishListResult {
    public result: boolean;
}

/* General */

export class CustomerInfo {

    public name: string;
    public surname: string;
    public mail: string;
    public phone: string;
    public counter: number;
    public privacy: boolean;
}

/* Configuration */

export class ConfigurationInfo {
    public wishList: WishListItem[];
    public isMobile: boolean;
    public isCassettiera: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models.ts